<template>
  <v-container fluid style="height: 100%;" class="pa-0 ma-0">
    <div class="header">
      <strong>{{ supplierName }} &rsaquo; New Product</strong>
    </div>
    <v-col cols="12" class="ma-0 pa-0">
      <v-tabs centered v-model="tab">
        <v-tab href="#tab-1" class="tabs">Setup</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <Create :supplier-id="$route.params.supplier_id" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-container>
</template>

<script>
import Create from "./ProductForm.vue";

export default {
  components: { Create },
  data: () => ({
    tab: null,
    supplierName: '',
  }),
  async mounted() {
    const { data } = await this.$axios.get(`admin/suppliers/get_supplier/${this.$route.params.supplier_id}`)
    if (data.response) {
      this.supplierName = data.data.supplier_name
    }
  },
}
</script>

<style scoped lang="scss">
.header {
  max-width: 100%;
  height: 50px;
  text-align: center;
  position: relative;
  z-index: 1;
  line-height: 50px;
}

.tabs {
  text-transform: none !important;
}
</style>
